import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AppShell from './components/layout/AppShell';
import HomePage from './pages/HomePage';
import PortfoliosPage from './pages/PortfoliosPage';
import PortfolioCreatePage from './pages/PortfolioCreatePage';
import PortfolioPage from './pages/PortfolioPage';
import PortfolioSettingsPage from './pages/PortfolioSettingsPage';
import HoldingDetailPage from './pages/HoldingDetailPage';
import ProfileSettingsPage from './pages/ProfileSettingsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import CompleteRegistrationPage from './pages/CompleteRegistrationPage';
import AdminPage from './pages/AdminPage';
import AdminUserDetailPage from './pages/AdminUserDetailPage';
import AdminStubPage from './pages/AdminStubPage';
import InstrumentDetailPage from './pages/InstrumentDetailPage';
import DemoPortfolioDetailPage from './pages/DemoPortfolioDetailPage';
import StocksWorkspace from './pages/stocks/StocksWorkspace';
import StocksOverviewPage from './pages/stocks/StocksOverviewPage';
import StocksHeatmapPage from './pages/stocks/StocksHeatmapPage';
import StocksFearGreedPage from './pages/stocks/StocksFearGreedPage';
import CryptoWorkspace from './pages/crypto/CryptoWorkspace';
import CryptoOverviewPage from './pages/crypto/CryptoOverviewPage';
import CryptoHeatmapPage from './pages/crypto/CryptoHeatmapPage';
import CryptoFearGreedPage from './pages/crypto/CryptoFearGreedPage';
import NotFoundPage from './pages/NotFoundPage';
import AdminLandingPreviewPage from './pages/AdminLandingPreviewPage';
import AdminProgressPage from './pages/AdminProgressPage';
import LegalHubPage from './pages/legal/LegalHubPage';
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage';
import TermsOfServicePage from './pages/legal/TermsOfServicePage';
import SubprocessorsPage from './pages/legal/SubprocessorsPage';
import CookiePolicyPage from './pages/legal/CookiePolicyPage';
import { NavActionsProvider } from './context/NavActionsContext';
import { AuthProvider } from './context/AuthContext';
import CookieConsent from './components/ui/CookieConsent';

function App() {
  return (
    <AuthProvider>
      <NavActionsProvider>
        <CookieConsent />
        <Routes>
          {/* Auth stránky – bez AppShell (vlastní layout) */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/complete-registration" element={<CompleteRegistrationPage />} />

          {/* Legal — no AppShell, public, no auth required */}
          <Route path="/legal"          element={<LegalHubPage />} />
          <Route path="/privacy"        element={<PrivacyPolicyPage />} />
          <Route path="/terms"          element={<TermsOfServicePage />} />
          <Route path="/subprocessors"  element={<SubprocessorsPage />} />
          <Route path="/cookies"        element={<CookiePolicyPage />} />

          {/* Hlavní app */}
          <Route element={<AppShell />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/portfolios" element={<PortfoliosPage />} />
            <Route path="/portfolios/new" element={<PortfolioCreatePage />} />
            <Route path="/portfolios/demo/:demoId" element={<DemoPortfolioDetailPage />} />
            <Route path="/portfolio/:slug" element={<PortfolioPage />} />
            <Route path="/portfolio/:slug/settings" element={<PortfolioSettingsPage />} />
            <Route path="/portfolio/:slug/:ticker" element={<HoldingDetailPage />} />
            <Route path="/profile" element={<ProfileSettingsPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/users/:id" element={<AdminUserDetailPage />} />
            <Route path="/admin/landing"  element={<AdminLandingPreviewPage />} />
            <Route path="/admin/progress" element={<AdminProgressPage />} />
            <Route path="/admin/roadmap"  element={<AdminStubPage title="Roadmap editor"         description="Edit the homepage roadmap directly from the UI." />} />

            <Route path="/settings"        element={<AdminStubPage title="Settings"      description="Global app settings." requireAdmin={false} />} />
            <Route path="/commodities"     element={<AdminStubPage title="Commodities"  description="Gold, Oil, Silver, Natural Gas and other commodity markets. Coming soon." />} />
            {/* Stocks workspace — shared batch-quote context */}
            <Route element={<StocksWorkspace />}>
              <Route path="/stocks"             element={<StocksOverviewPage />} />
              <Route path="/stocks/heatmap"     element={<StocksHeatmapPage />} />
              <Route path="/stocks/fear-greed"  element={<StocksFearGreedPage />} />
            </Route>
            <Route path="/stocks/:ticker" element={<InstrumentDetailPage assetType="Stock" />} />

            {/* Crypto workspace — shared batch-quote context */}
            <Route element={<CryptoWorkspace />}>
              <Route path="/crypto"             element={<CryptoOverviewPage />} />
              <Route path="/crypto/heatmap"     element={<CryptoHeatmapPage />} />
              <Route path="/crypto/fear-greed"  element={<CryptoFearGreedPage />} />
            </Route>
            <Route path="/crypto/:ticker" element={<InstrumentDetailPage assetType="Crypto" />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </NavActionsProvider>
    </AuthProvider>
  );
}

export default App;